<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="h-auto md:h-[80vh] rounded-2xl overflow-hidden mt-32 flex">
      <!-- Left Image -->
      <div
        class="hidden md:block md:w-1/2 bg-cover bg-center"
        style="
          background-image: url('./login.png');
        "
      ></div>

      <!-- Right Section -->
      <div
        class="flex flex-col justify-center md:w-1/2 px-5 md:py-0 py-5 md:px-16 bg-white"
      >
        <h2
          class="text-4xl font-extrabold mb-6"
          [style.color]="'var(--primary)'"
        >
          Verify Your Email
        </h2>
        <p class="text-gray-700 mb-6 max-w-md">
          We’ve sent a verification link to your email address.  
          Please check your inbox and click the link to verify your account.
        </p>

        <button
          (click)="resendVerification()"
          [disabled]="loading"
          [class]="
            loading
              ? ''
              : 'hover:bg-white hover:text-[var(--primary)] cursor-pointer'
          "
          class="w-full max-w-md flex items-center justify-center gap-1 py-3 bg-[var(--primary)] text-white rounded-xl font-semibold border border-[var(--primary)] transition"
        >
          @if(loading){
          <svg
            class="animate-spin h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            ></path>
          </svg>
          Sending... }@else { Resend Verification Email }
        </button>

        <p class="mt-6 text-gray-700">
          Already verified?  
          <a
            (click)="navigateToReturnUrl()"
            class="text-[var(--primary)] font-semibold hover:underline cursor-pointer"
            >Reload</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
